<template>
  <AdminAppLayout title="HRDOS | Account Validation"> 
    <div class="row" style="margin-bottom: 15px;">
        <div class="col s12 m4" style="min-width: 200px !important; cursor: pointer;" @click="setFilter('for_validation')">
          <div class="card hoverable transition-card" :class="currentFilter === 'for_validation' ? 'orange darken-2' : 'white'">
            <div class="card-content left-align filter-card" :class="currentFilter === 'for_validation' ? 'white-text' : 'grey-text text-darken-3'">
              <h3 style="margin-top: 0;"><b>{{ counts.pending }}</b></h3>
              <p style="font-size: 1.1rem;font-weight: bold;">PENDING VALIDATION</p>
            </div>
          </div>
        </div>

        <div class="col s12 m4" style="min-width: 200px !important; cursor: pointer;" @click="setFilter('returned')">
          <div class="card hoverable transition-card" :class="currentFilter === 'returned' ? 'orange darken-4' : 'white'">
            <div class="card-content left-align filter-card" :class="currentFilter === 'returned' ? 'white-text' : 'grey-text text-darken-3'">
              <h3 style="margin-top: 0;"><b>{{ counts.returned }}</b></h3>
              <p style="font-size: 1.1rem;font-weight: bold;">RETURNED ACCOUNTS</p>
            </div>
          </div>
        </div>

        <div class="col s12 m4" style="min-width: 200px !important; cursor: pointer;" @click="setFilter('declined')">
          <div class="card hoverable transition-card" :class="currentFilter === 'declined' ? 'red darken-2' : 'white'">
            <div class="card-content left-align filter-card" :class="currentFilter === 'declined' ? 'white-text' : 'grey-text text-darken-3'">
              <h3 style="margin-top: 0;"><b>{{ counts.declined }}</b></h3>
              <p style="font-size: 1.1rem;font-weight: bold;">DECLINED ACCOUNTS</p>
            </div>
          </div>
        </div>
    </div>

    <div class="row" style="margin-bottom: 10px;">
      <div class="search-wrapper valign-wrapper col s12">
        <i class="material-icons indigo-text text-lighten-4" style="margin-right: 10px;">search</i>
        <div class="input-field search" style="width: 100%; margin: 0;">
          <input 
          id="search" 
          type="text"
          v-model="search"
          @input="handleSearchInputDelay"
          class="custom-search-input" 
          :placeholder="`Search ${currentFilter.replace('_', ' ')} accounts (name or ID...)`">
        </div>
      </div>
    </div>

    <div class="divider" style="margin-bottom: 25px;border-bottom: 2px dashed #283593;"></div>

    <div class="table-responsive-wrapper hide-on-med-and-down" v-show="listLoader">
      <table class="highlight">
        <thead>
          <tr>
            <th>No.</th>
            <th>Profile</th>
            <th class="nowrap">LTO ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Date Added</th>
            <th class="nowrap center-align">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="n in 5" :key="'skeleton-row-' + n">
            <td><div class="skeleton skeleton-text" style="width: 20px;"></div></td>
            <td style="width: 60px;">
              <div class="skeleton skeleton-circle" style="width: 60px; height: 60px;"></div>
            </td>
            <td><div class="skeleton skeleton-text" style="width: 70px;"></div></td>
            <td><div class="skeleton skeleton-text" style="width: 130px;"></div></td>
            <td><div class="skeleton skeleton-text" style="width: 160px;"></div></td>
            <td><div class="skeleton skeleton-text" style="width: 80px;"></div></td>
            <td class="nowrap center-align"><div class="skeleton skeleton-button" style="margin: 0 auto;"></div></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-responsive-wrapper hide-on-med-and-down" v-show="!listLoader">
      <table class="highlight">
        <thead>
          <tr>
            <th>No.</th>
            <th>Profile</th>
            <th class="nowrap">LTO ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Date Added</th>
            <th class="nowrap center-align">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!filteredEmployees || !filteredEmployees.length">
            <td class="center-align" colspan="7">No {{ currentFilter.replace('_', ' ') }} accounts found...</td>
          </tr>

          <tr v-else v-for="(employee, i) in filteredEmployees" :key="employee.id">
            <td>{{ i+1 }}</td>
            <td style="width: 60px;">
              <img class="circle" style="object-fit: cover;width: 60px;height: 60px;" :src="getPhoto(employee.profile_photo)" alt="Profile">
            </td>
            <td><b>{{ employee.employee_id_number }}</b></td>
            <td>{{ employee.first_name }} {{ employee.last_name }}</td>
            <td>{{ employee.user?.email || 'N/A' }}</td>
            <td>{{ formatDate(employee.created_at) }}</td>
            <td class="nowrap center-align">
              <button @click="getEmployeeDetails(employee.id)" class="btn-small blue darken-2" style="border-radius: 4px;">
                <i class="material-icons left" style="margin-right: 5px;">
                  {{ currentFilter === 'for_validation' ? 'assignment' : 'visibility' }}
                </i>
                <b>{{ currentFilter === 'for_validation' ? 'Review' : 'View' }}</b>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row hide-on-large-only left-align" v-show="listLoader">
      <div v-for="n in 4" :key="'skeleton-mobile-' + n" class="col s12 m6">
        <div style="height: 180px; box-shadow: none; border: 1px solid #f5f5f5;" class="card horizontal">
          <div style="max-width: 35%; min-width: 35%; height: 100%;" class="skeleton"></div>
          <div class="card-stacked">
            <div class="card-content">
              <div class="skeleton skeleton-text" style="width: 85%; height: 16px; margin-bottom: 20px;"></div>
              <div class="skeleton skeleton-text" style="width: 65%; height: 16px;"></div>
            </div>
            <div class="card-action" style="display: flex; align-items: center;">
              <div class="skeleton skeleton-button" style="margin: 2%; width: 100%;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row hide-on-large-only left-align" v-show="!listLoader">
      <div v-for="employee in filteredEmployees" :key="employee.id" class="col s12 m6">
        <div style="height: 180px;" class="card horizontal">
          <div style="max-width: 35%;min-width: 35%;" class="card-image">
            <img style="width: 100%;height: 100%;object-fit: cover;" :src="getPhoto(employee.profile_photo)">
          </div>
          <div class="card-stacked" style="overflow: hidden;">
            <div class="card-content" style="padding: 15px;">
              <p class="truncate"><b>LTO ID : <span>{{ employee.employee_id_number }}</span></b></p>
              <p class="truncate" :title="employee.first_name + ' ' + employee.last_name"><b>Name : <span>{{ employee.first_name }} {{ employee.last_name }}</span></b></p>
              <p class="grey-text truncate" style="font-size: 0.85rem; margin-top: 5px;">Submitted: {{ formatDate(employee.created_at) }}</p>
            </div>
            <div class="card-action" style="padding: 10px 15px;">
                <button @click="getEmployeeDetails(employee.id)" class="btn-small blue darken-2" style="border-radius: 4px; width: 100%;">
                  <b>{{ currentFilter === 'for_validation' ? 'Review Account' : 'View Account' }}</b>
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="reviewDiv" class="modal modal-fixed-footer main-modal">
      
      <div class="modal-content white lighten-4" style="padding: 0;">
        
        <div class="modal-header blue" style="display: flex; justify-content: space-between; align-items: center; padding: 15px 24px; position: sticky; top: 0; z-index: 10;">
          <h5 class="white-text" style="margin: 0; font-weight: 600;">Employee Information</h5>
          <a href="#!" class="modal-close white-text close-x-btn" style="display: flex; align-items: center; justify-content: center; padding: 4px; border-radius: 50%;">
            <i class="material-icons" style="font-size: 2rem;">close</i>
          </a>
        </div>

        <div style="padding: 24px;">
          <div class="content-skeleton" v-show="detailsLoader">
            <div class="row profile-hero center-align">
              <div class="col s12">
                <div class="skeleton skeleton-circle" style="width: 140px; height: 140px; margin: 0 auto 15px auto; border: 4px solid #ffffff; box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);"></div>
                <div class="skeleton" style="width: 250px; height: 28px; border-radius: 4px; margin: 0 auto 10px auto;"></div>
                <div class="skeleton" style="width: 160px; height: 32px; border-radius: 20px; margin: 0 auto;"></div>
              </div>
            </div>
            <div class="row">
              <div class="col s12 m6">
                <div class="card info-card z-depth-0">
                  <div class="card-content center-align">
                    <div class="skeleton" style="width: 50%; height: 24px; border-radius: 4px; margin: 0 auto 25px auto;"></div>
                    <div class="info-item" style="margin-bottom: 20px;">
                      <div class="skeleton" style="width: 30%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                      <div class="skeleton" style="width: 40%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col s12 m6">
                <div class="card info-card z-depth-0">
                  <div class="card-content center-align">
                    <div class="skeleton" style="width: 55%; height: 24px; border-radius: 4px; margin: 0 auto 25px auto;"></div>
                    <div class="info-item row" style="margin-bottom: 20px;">
                      <div class="col s6">
                        <div class="skeleton" style="width: 35%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                        <div class="skeleton" style="width: 70%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                      </div>
                      <div class="col s6">
                        <div class="skeleton" style="width: 25%; height: 10px; border-radius: 4px; margin: 0 auto 8px auto;"></div>
                        <div class="skeleton" style="width: 80%; height: 18px; border-radius: 4px; margin: 0 auto;"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="content" v-show="!detailsLoader">
  
            <div v-if="currentFilter !== 'for_validation' && employeeModal.remarks" class="row" style="margin-bottom: 15px;">
              <div class="col s12">
                <div class="card-panel" :class="currentFilter === 'declined' ? 'red lighten-5 red-text text-darken-3' : 'orange lighten-5 orange-text text-darken-4'" style="border-radius: 8px; padding: 15px;">
                  <h6 style="margin-top: 0; font-weight: bold;">
                    <i class="material-icons left" style="font-size: 1.2rem;">info_outline</i>
                    Reason for {{ currentFilter === 'declined' ? 'Decline' : 'Return' }}
                  </h6>
                  <p style="margin-bottom: 0;">{{ employeeModal.remarks }}</p>
                </div>
              </div>
            </div>
            
            <div v-if="employeeModal.submitter_remarks && currentFilter === 'for_validation'" class="row" style="margin-bottom: 15px;">
              <div class="col s12">
                <div class="card-panel blue lighten-5 blue-text text-darken-4" style="border-radius: 8px; padding: 15px;">
                  <h6 style="margin-top: 0; font-weight: bold;">
                    <i class="material-icons left" style="font-size: 1.2rem;">reply</i>
                    Submitter's Note
                  </h6>
                  <p style="margin-bottom: 0;">{{ employeeModal.submitter_remarks }}</p>
                </div>
              </div>
            </div>

            <div class="row profile-hero center-align">
              <div class="col s12">
                <img :src="getPhoto(employeeModal.profile_photo)" class="profile-avatar white" alt="Profile Photo">
                <h4 class="employee-name">
                  {{ employeeModal.first_name }} {{ employeeModal.middle_name ? employeeModal.middle_name + ' ' : '' }}{{ employeeModal.last_name }}
                </h4>
                <div class="employee-badge blue darken-1 white-text" style="padding: 5px 15px; border-radius: 20px; display: inline-block;">
                  LTO ID: <b>{{ employeeModal.employee_id_number }}</b>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col s12 m6">
                <div class="card info-card z-depth-0">
                  <div class="card-content">
                    <h5 class="info-card-title blue-text text-darken-2">Personal Information</h5>
                    <div class="info-item">
                      <span class="info-label">Mobile Number</span>
                      <div class="info-value"><b>{{ employeeModal.cellphone_number || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Email Address</span>
                      <div class="info-value"><b>{{ employeeModal.user?.email || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Address</span>
                      <div class="info-value"><b>{{ employeeModal.address || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Birthplace</span>
                      <div class="info-value"><b>{{ employeeModal.birthplace || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item row" style="margin-bottom: 0;">
                      <div class="col s6" style="padding-left: 0;">
                        <span class="info-label">Birthday</span>
                        <div class="info-value"><b>{{ formatDate(employeeModal.birthday) }}</b></div>
                      </div>
                      <div class="col s6">
                        <span class="info-label">Sex</span>
                        <div class="info-value"><b>{{ employeeModal.sex || 'N/A' }}</b></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="col s12 m6">
                <div class="card info-card z-depth-0">
                  <div class="card-content">
                    <h5 class="info-card-title green-text text-darken-2">Employment Details</h5>
                    <div class="info-item row" style="margin-bottom: 20px;">
                      <div class="col s6" style="padding-left: 0;">
                        <span class="info-label">Position</span>
                        <div class="info-value"><b>{{ employeeModal.position?.title || 'N/A' }}</b></div>
                      </div>
                      <div class="col s6">
                        <span class="info-label">Item</span>
                        <div class="info-value"><b>{{ employeeModal.item_number || 'N/A' }}</b></div>
                      </div>
                    </div>
                    <div class="info-item">
                        <span class="info-label">Plantilla</span>
                        <div class="info-value"><b>{{ employeeModal.plantilla?.name || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item">
                        <span class="info-label">Current Office Assigned</span>
                        <div class="info-value"><b>{{ employeeModal.assigned_office?.name || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item row" style="margin-bottom: 20px;">
                      <div class="col s6" style="padding-left: 0;">
                        <span class="info-label">Employment Status</span>
                        <div class="info-value"><b>{{ employeeModal.employment_status?.name || 'N/A' }}</b></div>
                      </div>
                      <div class="col s6">
                        <span class="info-label">{{ employeeModal.employment_status?.id === 3 ? 'Date Hired' : 'Employment Date' }}</span>
                        <div class="info-value"><b>{{ formatDate(employeeModal.effectivity_date) }}</b></div>
                      </div>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Civil Service Eligibility</span>
                      <div class="info-value"><b>{{ employeeModal.eligibility?.name || 'N/A' }}</b></div>
                    </div>
                    <div class="info-item row" style="margin-bottom: 0;">
                      <div class="col s6" style="padding-left: 0;">
                        <span class="info-label">Salary Grade</span>
                        <div class="info-value"><b>{{ employeeModal.salary_grade ? 'SG '+ employeeModal.salary_grade.grade : 'N/A' }}</b></div>
                      </div>
                      <div class="col s6">
                        <span class="info-label">Base Salary</span>
                        <div class="info-value"><b>{{ employeeModal.salary_grade ? '₱ ' + employeeModal.salary_grade.salary_amount : '₱ ' + employeeModal.base_salary }}</b></div>
                      </div>
                    </div>
                    
                    <div class="info-item card-panel grey lighten-5 z-depth-0 center-align" style="padding: 15px; margin-top: 15px; border: 1px solid #e0e0e0;">
                      <span class="info-label" style="margin-bottom: 15px;">Government IDs</span>
                      
                      <div class="row" style="margin-bottom: 0;">
                        <div class="col s12 m4" style="margin-bottom: 15px;">
                          <span class="info-label" style="font-size: 0.75rem;">TIN</span>
                          <div class="info-value" style="font-size: 0.95rem; white-space: nowrap;"><b>{{ employeeModal.tin || 'N/A' }}</b></div>
                        </div>
                        
                        <div class="col s12 m4" style="margin-bottom: 15px;">
                          <span class="info-label" style="font-size: 0.75rem;">SSS</span>
                          <div class="info-value" style="font-size: 0.95rem; white-space: nowrap;"><b>{{ employeeModal.sss || 'N/A' }}</b></div>
                        </div>
                        
                        <div class="col s12 m4" style="margin-bottom: 15px;">
                          <span class="info-label" style="font-size: 0.75rem;">GSIS</span>
                          <div class="info-value" style="font-size: 0.95rem; white-space: nowrap;"><b>{{ employeeModal.gsis || 'N/A' }}</b></div>
                        </div>
                        
                        <div class="col s12 m6" style="margin-bottom: 10px;">
                          <span class="info-label" style="font-size: 0.75rem;">Pag-IBIG</span>
                          <div class="info-value" style="font-size: 0.95rem; white-space: nowrap;"><b>{{ employeeModal.pagibig || 'N/A' }}</b></div>
                        </div>
                        
                        <div class="col s12 m6" style="margin-bottom: 10px;">
                          <span class="info-label" style="font-size: 0.75rem;">PhilHealth</span>
                          <div class="info-value" style="font-size: 0.95rem; white-space: nowrap;"><b>{{ employeeModal.philhealth || 'N/A' }}</b></div>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="row" style="padding-top: 20px;">
              <div class="col s12 center-align grey-text text-darken-1">
                <i class="material-icons" style="font-size: 1.1rem; vertical-align: text-bottom;">history</i>
                <span style="font-size: 0.95rem; margin-left: 5px;">
                  Record created on <b>{{ formatDate(employeeModal.created_at) }}</b>
                  <span v-if="employeeModal.creator">
                     by <b>{{ creatorName || employeeModal.creator.username || employeeModal.creator.email }}</b>
                  </span>
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
      
      <div class="modal-footer grey lighten-3 custom-footer">
        <a href="#!" class="modal-close btn-flat waves-grey" style="margin: 0; padding: 0 10px;">Close</a>
        
        <div v-if="currentFilter === 'for_validation'" class="footer-actions">
          <button type="button" @click="promptRemarks('decline', employeeModal?.id)" class="btn red darken-2" :disabled="actionLoader">
            <i class="material-icons left">delete_forever</i> Decline
          </button>

          <button type="button" @click="promptRemarks('return', employeeModal?.id)" class="btn orange darken-4" :disabled="actionLoader">
            <i class="material-icons left">assignment_return</i> Return
          </button>
          
          <button type="button" @click="promptApprove(employeeModal?.id)" class="btn green darken-1" :disabled="actionLoader">
            <i class="material-icons left">check</i> Approve
          </button>
        </div>

        <div v-else class="footer-actions">
          <button type="button" @click="promptConfirm('revert', employeeModal?.id)" class="btn blue darken-2" :disabled="actionLoader">
            <i class="material-icons left">restore</i> Revert to Pending
          </button>
        </div>
      </div>
    </div>

    <div id="confirmModal" class="modal confirm-modal">
      <div class="modal-content center-align">
        <i class="material-icons" :class="confirmState.iconClass" style="font-size: 4.5rem; margin-bottom: 10px;">help_outline</i>
        <h5 style="font-weight: 700; margin-top: 0; margin-bottom: 15px; color: #2c3e50;">{{ confirmState.title }}</h5>
        <p class="grey-text text-darken-1" style="font-size: 1.1rem; line-height: 1.5; margin: 0;">{{ confirmState.message }}</p>
      </div>
      <div class="modal-footer" style="display: flex; justify-content: center; gap: 15px; padding: 20px 24px 30px; background-color: transparent; margin-bottom: 1%;">
        <button class="modal-close btn-flat waves-grey grey lighten-4 grey-text text-darken-3 confirm-btn-cancel">Cancel</button>
        <button @click="executeConfirmAction" class="btn confirm-btn-action" :class="confirmState.btnClass" :disabled="actionLoader">
          <span v-if="actionLoader">Processing...</span>
          <span v-else>Yes, Proceed</span>
        </button>
      </div>
    </div>

    <div id="remarksModal" class="modal remarks-modal">
      <div class="modal-content center-align" style="padding: 30px 24px 10px;">
        <i class="material-icons" :class="remarksState.color" style="font-size: 4rem; margin-bottom: 10px;">{{ remarksState.icon }}</i>
        <h5 style="font-weight: 700; margin-top: 0; margin-bottom: 15px; color: #2c3e50;">{{ remarksState.title }}</h5>

        <div class="card-panel" :class="remarksState.bgClass" style="border: 1px solid #ef9a9a; border-radius: 8px; padding: 15px;">
          <div class="input-field" style="margin-bottom: 0; margin-top: 0;">
            <textarea id="modalRemarks" v-model="remarks" class="materialize-textarea white" :placeholder="remarksState.placeholder" style="border-radius: 4px; padding: 10px; box-sizing: border-box; border: 1px solid #ccc; min-height: 80px;"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="display: flex; justify-content: center; gap: 15px; padding: 10px 24px 30px; background-color: transparent; margin-bottom: 5%;">
        <button class="modal-close btn-flat waves-grey grey lighten-4 grey-text text-darken-3 confirm-btn-cancel">Cancel</button>
        <button @click="executeRemarksAction" class="btn confirm-btn-action" :class="remarksState.btnClass" :disabled="actionLoader">
          <span v-if="actionLoader">Submitting...</span>
          <span v-else>{{ remarksState.btnText }}</span>
        </button>
      </div>
    </div>

    <div id="approveModal" class="modal approve-modal">
      <div class="modal-content center-align" style="padding: 30px 24px 10px;">
        <i class="material-icons green-text text-darken-1" style="font-size: 4rem; margin-bottom: 10px;">check_circle_outline</i>
        <h5 style="font-weight: 700; margin-top: 0; margin-bottom: 15px; color: #2c3e50;">Approve Registration</h5>
        <p class="grey-text text-darken-1" style="font-size: 1rem; margin-bottom: 25px;">Please assign a system role for this user before finalizing the approval.</p>

        <div class="input-field left-align" style="margin-bottom: 20px;">
          <select id="userRoleSelect" v-model="selectedRole" class="browser-default" style="border: 1px solid #ccc; border-radius: 4px; padding: 5px; height: 3rem; font-size: 1.1rem; width: 100%;">
            <option value="" disabled>Select User Role</option>
            <option value="employee">Employee</option>
            <option value="admin">HR Assistant</option>
          </select>
          <label class="active" style="transform: translateY(-29px) scale(0.8);">Assign System Role</label>
        </div>
      </div>
      <div class="modal-footer" style="display: flex; justify-content: center; gap: 15px; padding: 10px 24px 30px; background-color: transparent; margin-bottom: 5%;">
        <button class="modal-close btn-flat waves-grey grey lighten-4 grey-text text-darken-3 confirm-btn-cancel">Cancel</button>
        <button @click="executeApproveAction" class="btn green darken-1 confirm-btn-action" :disabled="actionLoader || !selectedRole">
          <span v-if="actionLoader">Processing...</span>
          <span v-else>Approve Account</span>
        </button>
      </div>
    </div>
    
  </AdminAppLayout>
</template>

<style scoped>
@media only screen and (max-width: 992px) {
  .main-modal { width: 95%; }
}
@media only screen and (min-width: 993px) {
  .main-modal { width: 80%; }
}

#search::placeholder {
  color: #4b4b4b;
}

.transition-card {
  transition: all 0.3s ease;
}

/* Enforce Strict Height for the Fixed Footer Modal */
.main-modal {
  border-radius: 20px;
  height: 85% !important;
  max-height: 85% !important;
}

/* Modal Content and Header Fixes */
.main-modal .modal-content {
  height: calc(100% - 65px) !important; 
}

.modal-header {
  border-bottom: 1px solid rgba(0,0,0,0.1);
}

.close-x-btn {
  transition: background-color 0.2s ease;
}
.close-x-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.custom-footer {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding: 0 24px !important;
  overflow: hidden !important; 
  border-radius: 0 0 20px 20px;
  height: 65px !important; 
}

.footer-actions {
  display: flex;
  gap: 10px;
}

.footer-actions .btn {
  margin: 0;
  border-radius: 6px;
  display: flex;
  align-items: center;
}

@media only screen and (max-width: 600px) {
  .footer-actions .btn {
    padding: 0 10px;
    font-size: 0.8rem;
  }
  .footer-actions .btn i {
    margin-right: 5px;
    font-size: 1.2rem;
  }
  .custom-footer {
    padding: 0 12px !important;
  }
}

.confirm-modal {
  width: 420px !important;
  max-width: 90%;
  border-radius: 16px;
  min-height: auto;
  overflow: hidden;
  top: 35% !important; 
}
.confirm-modal .modal-content {
  padding: 40px 24px 10px;
}

.remarks-modal {
  width: 500px !important;
  max-width: 95%;
  border-radius: 16px;
  min-height: auto;
  overflow: hidden;
  top: 30% !important; 
}

/* Approve Modal Centering */
.approve-modal {
  width: 450px !important;
  max-width: 90%;
  border-radius: 16px;
  min-height: auto;
  overflow: hidden;
  top: 30% !important; 
}

.confirm-btn-cancel, .confirm-btn-action {
  border-radius: 8px;
  padding: 0 24px;
  font-weight: 600;
  text-transform: none;
  height: 40px;
  line-height: 40px;
}
.confirm-btn-action {
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.profile-hero {
  margin-top: 10px;
  margin-bottom: 25px;
}
.profile-avatar {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 50%;
  border: 4px solid #ffffff;
  box-shadow: 0 4px 8px #e0e0e0;
  margin-bottom: 10px;
}
.employee-name {
  margin: 0 0 10px 0;
  font-weight: bold;
  font-size: 1.8rem;
  color: #212121;
}

.info-label {
  display: block;
  font-size: 0.85rem;
  color: #757575;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
}
.info-value {
  font-size: 1.1rem;
  color: #212121;
}

.table-responsive-wrapper {
  overflow-x: auto;
  width: 100%;
  margin-bottom: 20px;
}

.table-responsive-wrapper table {
  min-width: 1000px;
}

.nowrap {
  white-space: nowrap;
}

tbody tr td {
  padding: 10px 5px;
  font-size: 1rem;
  vertical-align: middle;
}

thead th {
  font-size: 1.1rem;
  font-weight: bold;
}

#reviewDiv .info-item {
  margin-top: 20px !important; 
}

button i {
  margin-right: 0 !important;
}
</style>

<script>
import { api, apiURL } from "@/axios";
import AdminAppLayout from "../../layout/AdminAppLayout.vue";
import defaultPic from '@/assets/picDefault.png';


export default {
  name: "AccountValidation",
  components: {
    AdminAppLayout,
  },
  data() {
    return {
      search: '',
      typingTimer: null,
      selectedPage: 1,
      currentFilter: 'for_validation',
      
      filteredEmployees: [],
      
      counts: {
        pending: 0,
        returned: 0,
        declined: 0
      },
      
      detailsLoader: false,
      listLoader: false,
      actionLoader: false,
      remarks: '',
      creatorName: '',

      selectedRole: 'employee', 
      approveTargetId: null,

      employeeModal: {
        user: {},
        plantilla: {},
        employment_status: {},
        salary_grade: {},
        eligibility: {},
        position: {},
        assigned_office: {},
        creator: {}
      },

      confirmState: {
        action: null,
        id: null,
        title: '',
        message: '',
        iconClass: '',
        btnClass: ''
      },

      remarksState: {
        action: null,
        id: null,
        title: '',
        icon: '',
        color: '',
        bgClass: '',
        btnClass: '',
        btnText: '',
        placeholder: ''
      }
    };
  },
  methods: {

    setFilter(status) {
      this.currentFilter = status;
      this.search = ''; 
      this.selectedPage = 1;
      this.filterLists();
    },

    closeSafeModal() {
      const elem = document.getElementById('reviewDiv');
      if (elem) {
        let instance = window.M.Modal.getInstance(elem);
        if (!instance) {
           instance = window.M.Modal.init(elem, { preventScrolling: false, dismissible: false });
        }
        instance.close();
      }
    },

    getPhoto(photo) {
      if (photo){
        const baseUrl = apiURL.replace(/\/api\/?$/, '');
        return `${baseUrl}/storage/${photo}`;
      } else {
        return defaultPic;
      }
    },

    async filterLists(page = 1) {
      this.listLoader = true;
      this.selectedPage = page;

      await api.get(`/employees/validation-list?page=${page}&searchQuery=${this.search}&accountStatusQuery=${this.currentFilter}`)
      .then((res) => {
        this.filteredEmployees = res.data.employees.data;
        this.counts.pending = res.data.counts.pending;
        this.counts.returned = res.data.counts.returned;
        this.counts.declined = res.data.counts.declined;
        this.listLoader = false;
      })
      .catch((err) => {
        console.error(err);
        this.listLoader = false;
      })
    },

    handleSearchInputDelay() {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
            this.filterLists();
        }, 500);
    },

    formatDate(date) {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString('en-PH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },

    async getEmployeeDetails(id) {
      this.detailsLoader = true;
      this.remarks = ''; 
      
      const elem = document.getElementById('reviewDiv');
      let instance = window.M.Modal.getInstance(elem);
      if(!instance) instance = window.M.Modal.init(elem, { preventScrolling: false, dismissible: false });
      instance.open();

      await api.get(`/employee/${id}`)
        .then((res) => {
          this.employeeModal = res.data;
          this.detailsLoader = false;
          this.creatorName = this.employeeModal.creator && this.employeeModal.creator.employee ? this.employeeModal.creator.employee.full_name : '';
        })
        .catch((err) => {
          console.error(err);
          this.detailsLoader = false;
        });
    },

    promptConfirm(action, id) {
      this.confirmState.action = action;
      this.confirmState.id = id;

      if (action === 'revert') {
        this.confirmState.title = 'Revert to Pending?';
        this.confirmState.message = 'Are you sure you want to pull this account back into the pending queue?';
        this.confirmState.iconClass = 'blue-text text-darken-2';
        this.confirmState.btnClass = 'blue darken-2';
      }

      const elem = document.getElementById('confirmModal');
      let instance = window.M.Modal.getInstance(elem);
      if(!instance) instance = window.M.Modal.init(elem, { dismissible: false });
      instance.open();
    },

    executeConfirmAction() {
       if (this.confirmState.action === 'revert') this.revertAccount(this.confirmState.id);
    },

    closeConfirmModal() {
      const elem = document.getElementById('confirmModal');
      if (elem) window.M.Modal.getInstance(elem).close();
    },

    // === APPROVE ROLE MODAL LOGIC ===
    promptApprove(id) {
      this.approveTargetId = id;
      this.selectedRole = 'employee'; // Reset to default role

      const elem = document.getElementById('approveModal');
      let instance = window.M.Modal.getInstance(elem);
      if(!instance) instance = window.M.Modal.init(elem, { dismissible: false });
      instance.open();
    },

    executeApproveAction() {
       this.approveAccount(this.approveTargetId);
    },

    closeApproveModal() {
      const elem = document.getElementById('approveModal');
      if (elem) window.M.Modal.getInstance(elem).close();
    },

    // === DYNAMIC REMARKS MODAL LOGIC ===
    promptRemarks(action, id) {
      this.remarksState.action = action;
      this.remarksState.id = id;
      this.remarks = ''; 

      if (action === 'return') {
        this.remarksState.title = 'Return for Corrections';
        this.remarksState.icon = 'assignment_return';
        this.remarksState.color = 'orange-text text-darken-4';
        this.remarksState.bgClass = 'orange lighten-5';
        this.remarksState.btnClass = 'orange darken-4';
        this.remarksState.btnText = 'Submit Return';
        this.remarksState.placeholder = "Explain what needs to be fixed (e.g., 'Please upload a clearer ID').";
      } else if (action === 'decline') {
        this.remarksState.title = 'Decline Registration';
        this.remarksState.icon = 'cancel';
        this.remarksState.color = 'red-text text-darken-2';
        this.remarksState.bgClass = 'red lighten-5';
        this.remarksState.btnClass = 'red darken-2';
        this.remarksState.btnText = 'Submit Decline';
        this.remarksState.placeholder = "Explain the reason for declining this application permanently.";
      }

      const elem = document.getElementById('remarksModal');
      let instance = window.M.Modal.getInstance(elem);
      if(!instance) instance = window.M.Modal.init(elem, { dismissible: false });
      instance.open();
    },

    executeRemarksAction() {
      if (this.remarksState.action === 'return') {
         this.returnAccount(this.remarksState.id);
      } else if (this.remarksState.action === 'decline') {
         this.declineAccount(this.remarksState.id);
      }
    },

    closeRemarksModal() {
      const elem = document.getElementById('remarksModal');
      if (elem) window.M.Modal.getInstance(elem).close();
    },

    // === API CALLS ===
    async approveAccount(id) {
      this.actionLoader = true;
      // Send the selected role in the request body
      await api.post(`/employee/${id}/approve`, { role: this.selectedRole })
        .then(() => {
          window.M.toast({html: 'Account approved successfully!', classes: 'green rounded'});
          
          // INSTANT UI UPDATE: Remove the approved account from the list
          this.filteredEmployees = this.filteredEmployees.filter(emp => emp.id !== id);
          
          this.closeApproveModal();
          this.closeSafeModal();
          
          // Refresh lists to update the status counts, maintaining the current page
          this.filterLists(this.selectedPage); 
        })
        .catch((err) => {
          window.M.toast({html: 'Server Error: Check Laravel Logs!', classes: 'red rounded'});
          console.error(err);
        })
        .finally(() => { this.actionLoader = false; });
    },

    async returnAccount(id) {
      if (!this.remarks.trim()) {
         window.M.toast({html: 'Please provide remarks before returning.', classes: 'red rounded'});
         return; 
      }

      this.actionLoader = true;
      await api.post(`/employee/${id}/return`, { remarks: this.remarks })
        .then(() => {
          window.M.toast({html: 'Account returned for corrections.', classes: 'orange darken-2 rounded'});
          
          // INSTANT UI UPDATE: Remove the returned account from the list
          this.filteredEmployees = this.filteredEmployees.filter(emp => emp.id !== id);
          
          this.closeRemarksModal();
          this.closeSafeModal();
          this.filterLists(this.selectedPage);
        })
        .catch((err) => {
          window.M.toast({html: 'Server Error', classes: 'red rounded'});
          console.error(err);
        })
        .finally(() => { this.actionLoader = false; });
    },

    async declineAccount(id) {
      if (!this.remarks.trim()) {
         window.M.toast({html: 'Please provide a reason for declining.', classes: 'red rounded'});
         return; 
      }

      this.actionLoader = true;
      await api.post(`/employee/${id}/decline`, { remarks: this.remarks })
        .then(() => {
          window.M.toast({html: 'Account request declined.', classes: 'red darken-2 rounded'});
          
          // INSTANT UI UPDATE: Remove the declined account from the list
          this.filteredEmployees = this.filteredEmployees.filter(emp => emp.id !== id);
          
          this.closeRemarksModal();
          this.closeSafeModal();
          this.filterLists(this.selectedPage);
        })
        .catch((err) => {
          window.M.toast({html: 'Server Error', classes: 'red rounded'});
          console.error(err);
        })
        .finally(() => { this.actionLoader = false; });
    },

    async revertAccount(id) {
      this.actionLoader = true;
      await api.post(`/employee/${id}/revert`)
        .then(() => {
          window.M.toast({html: 'Account successfully reverted to pending.', classes: 'blue darken-2 rounded'});
          
          // INSTANT UI UPDATE: Remove the reverted account from the current view
          this.filteredEmployees = this.filteredEmployees.filter(emp => emp.id !== id);
          
          this.closeConfirmModal();
          this.closeSafeModal();
          this.filterLists(this.selectedPage);
        })
        .catch((err) => {
          window.M.toast({html: 'Server Error: Check Laravel Logs!', classes: 'red rounded'});
          console.error(err);
        })
        .finally(() => { this.actionLoader = false; });
    },
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const empId = this.$route?.query?.emp || urlParams.get('emp');

    this.$nextTick(() => {
      const modals = document.querySelectorAll('.modal');
      if (typeof window.M !== 'undefined') {
        window.M.Modal.init(modals, {
          preventScrolling: false,
          dismissible: false
        });
      }
    });

    if (empId) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.getEmployeeDetails(empId);
        }, 300); // A 300ms delay ensures the UI paints before the modal slides in
      });
    }

    this.filterLists(this.selectedPage); 
  }
};
</script>